/**
 * The handoff between "dropped anywhere" and the upload queue.
 *
 * The shell catches a drop on any screen, parks the files here, and navigates
 * to the Documents page, which collects them on mount. A module-level buffer
 * rather than context or state, deliberately: the value lives for one
 * navigation tick, has exactly one producer and one consumer, and wiring a
 * provider through the tree for that would be ceremony pretending to be
 * architecture.
 */

let buffer: File[] | null = null;

export function stashDroppedFiles(files: File[]): void {
  buffer = files;
}

export function takeDroppedFiles(): File[] | null {
  const taken = buffer;
  buffer = null;
  return taken;
}
